// Owner: slides-present-export (plan §4.1, §9.11). The `presentation` layer: decks and pages full screen
// with presenter view (features/present/PresentationLayer.tsx, loaded on first open). Open it with
// `openPresentation(request)` from `features/present` (it asks for full screen and opens the presenter
// window inside the click), or `openLayer('presentation', request)`.
import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';

export default defineGlobalLayer({
  id: 'presentation',
  component: lazy(() =>
    import('../features/present/PresentationLayer').then((m) => ({ default: m.PresentationLayer })),
  ),
});
